import React from "react";
import { useRecoilValue } from "recoil";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { PERMISSIONS } from "../../../PermissionsConstants";
import CameraSystemTable from "./view/CameraSystemTable";

interface CameraSystemProps {}
export const CameraSystem: React.FC<CameraSystemProps> = () => {
  const viewPermission =
    PERMISSIONS.permission_utilities_securityconfiguration_camerasystem_view;
  const userPermissions = useRecoilValue(permissionsSelector);
  return (
    <> {userPermissions.includes(viewPermission) && <CameraSystemTable />} </>
  );
};
export default CameraSystem;
